export enum SpecialDayTypeEnum {
    OTHER = '455ee6a9-cb54-4cff-b6cc-f8ffd2150831'
}
